import React, { Fragment, useState } from "react";

import "./TeamPage.css";

// ---- Leadership image imports ----
import img01 from "../../images/team/saurabh.png";
import img02 from "../../images/team/suresh.png";
import img03 from "../../images/team/sandeep.png";
import img04 from "../../images/team/pooja.png";
import img05 from "../../images/team/ramudu.png";
import img06 from "../../images/team/atul.png";
import img07 from "../../images/team/vijay.png";
import img08 from "../../images/team/anand.png";
import img09 from "../../images/team/img09.jpg";

import bgSmall from "../../images/team/noice-bg.png";

interface TeamMember {
  name: string;
  role: string;
  summary: string;
  details: string;
  expertise: string[];
  img: string;
  linkedin?: string;
}

const teamMembers: TeamMember[] = [
  {
    name: "Saurabh Dhingra",
    role: "Managing Director",
    summary:
      "Founder and Managing Director of Digicomm with more than 20 years of semiconductor industry experience.",
    details:
      "Saurabh has been responsible for defining Digicomm’s principles and values, shaping its relationships with clients, partners, and internal stakeholders while establishing an innovation- and value-driven organisational culture. Before founding Digicomm in 2012, he worked with Freescale and Wipro in electronic hardware and ASIC design roles.",
    expertise: [
      "Business Leadership",
      "Semiconductor Engineering",
      "ASIC Design",
    ],
    img: img01,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Suresh Krishnamurthy",
    role: "VP Engineering",
    summary:
      "AMS Group Head with more than 20 years of experience in semiconductor design and project management.",
    details:
      "Suresh has extensive implementation knowledge from specification to GDS, including schematic design, simulation, layout, post-layout simulation, tapeout, and mask generation. He has managed cross-functional and multi-site engineering programs and delivered designs with first-pass success.",
    expertise: [
      "Analog & Mixed Signal",
      "Specification to GDS",
      "Layout Design",
    ],
    img: img02,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Sandeep Kolte",
    role: "VP Engineering",
    summary:
      "Semiconductor technical leader with more than 20 years of engineering and team-management experience.",
    details:
      "Sandeep specialises in physical design, front-end design, logic synthesis, System-on-Chip development, and ASIC engineering. His experience also includes project management, engineering-team development, and technical program execution.",
    expertise: [
      "Physical Design",
      "Logic Synthesis",
      "ASIC & SoC",
    ],
    img: img03,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Pooja",
    role: "VP – HR & Operations",
    summary:
      "Experienced leader in front-end design, verification, people management, and organisational operations.",
    details:
      "Pooja brings more than 20 years of experience in front-end design and verification. She has contributed to complex SoC and IP-level verification programs and has experience in backend flow, system development, team management, and technical leadership.",
    expertise: [
      "HR & Operations",
      "Design Verification",
      "Technical Leadership",
    ],
    img: img04,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Ramudu Bathineni",
    role: "VP Engineering",
    summary:
      "ASIC and SoC verification specialist with more than 20 years of engineering experience.",
    details:
      "Ramudu has worked across IP, subsystem, and full-SoC verification using Verilog, VHDL, SystemVerilog, UVM, OVM, and ERM. His experience includes coverage-driven verification, assertion-based verification, gate-level verification, and processor-based SoC platforms.",
    expertise: [
      "ASIC Verification",
      "SystemVerilog & UVM",
      "SoC Verification",
    ],
    img: img05,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Atul K",
    role: "VP Engineering",
    summary:
      "VLSI design-verification leader with deep expertise in IP, SoC, and low-power verification.",
    details:
      "Atul brings more than 20 years of experience in VLSI design verification. His expertise includes IP and SoC verification, RTL simulation, gate-level simulation, power management, and power-aware simulation.",
    expertise: [
      "VLSI Verification",
      "RTL & GLS",
      "Low-Power Verification",
    ],
    img: img06,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Vijaymukilan S",
    role: "Director – Embedded Software",
    summary:
      "Head of Embedded Software Systems with extensive automotive and embedded-software experience.",
    details:
      "Vijaymukilan has more than 20 years of experience in embedded systems, automotive software, and DSP technologies. He specialises in AUTOSAR, ADAS, ARM-based platforms, embedded Linux, real-time software, and ISO 26262 functional safety.",
    expertise: [
      "Embedded Systems",
      "AUTOSAR & ADAS",
      "ISO 26262",
    ],
    img: img07,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Anand Date",
    role: "Director – Digital Design Front End",
    summary:
      "Digital-design leader with more than 25 years of experience across complex semiconductor platforms.",
    details:
      "Anand has experience in ASIC RTL design, front-end development, FPGA prototyping, emulation, and system architecture. He has delivered semiconductor and FPGA-based platforms across automotive, storage, networking, and other advanced technology domains.",
    expertise: [
      "ASIC RTL Design",
      "FPGA & Emulation",
      "System Architecture",
    ],
    img: img08,
    linkedin: "https://www.linkedin.com/",
  },
  {
    name: "Anand Bariya",
    role: "Advisory Board Member",
    summary:
      "Technology and operations leader with more than 25 years of global engineering experience.",
    details:
      "Anand has established and scaled multidisciplinary engineering centres and geographically distributed teams. His experience covers engineering operations, procurement, compliance, HR, finance, manufacturing scale-up, technology execution, and strategic partnerships.",
    expertise: [
      "Technology Leadership",
      "Global Operations",
      "Strategic Partnerships",
    ],
    img: img09,
    linkedin: "https://www.linkedin.com/",
  },
];

const TeamLeadership: React.FC = () => {
  const [selectedMember, setSelectedMember] =
    useState<TeamMember | null>(null);

  const openProfile = (member: TeamMember) => {
    setSelectedMember(member);
    document.body.style.overflow = "hidden";
  };

  const closeProfile = () => {
    setSelectedMember(null);
    document.body.style.overflow = "";
  };

  return (<Fragment>
            <section className="team digicomm-team-section">
              <div className="digicomm-team-glow digicomm-team-glow-one" />
              <div className="digicomm-team-glow digicomm-team-glow-two" />

              <div className="container">
                <div className="row">
                  <div className="col-xl-9 col-lg-10">
                    <div className="digicomm-team-heading">
                      <span className="digicomm-team-subtitle">
                        Meet the leadership team
                      </span>

                      <h2 className="digicomm-team-title">
                        Experienced leaders driving engineering excellence
                      </h2>

                      <p className="digicomm-team-description">
                        Our success is shaped by our commitment,
                        collaborative approach, engineering expertise,
                        and the way we work with our clients, partners,
                        and people.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row g-4 digicomm-team-grid">
                  {teamMembers.map((item) => (
                    <div
                      key={item.name}
                      className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                    >
                      <article className="xb-team-item xb-border digicomm-team-card">
                        <div className="xb-item--img digicomm-team-image">
                          <img
                            src={item.img}
                            alt={item.name}
                          />

                          <div className="digicomm-team-image-shade" />
                        </div>

                        <div className="xb-item--holder digicomm-team-holder">
                          <div className="xb-item--author digicomm-team-author">
                            <h2 className="xb-item--name digicomm-team-name">
                              {item.name}
                            </h2>

                            <span className="xb-item--desig digicomm-team-role">
                              {item.role}
                            </span>
                          </div>

                          <div className="digicomm-team-actions">
                            <button
                              type="button"
                              className="digicomm-team-info-button"
                              onClick={() => openProfile(item)}
                              aria-label={`Read about ${item.name}`}
                            >
                              <i className="fa-solid fa-info" />
                            </button>

                            {item.linkedin && (
                              <a
                                href={item.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="digicomm-team-linkedin"
                                aria-label={`${item.name} LinkedIn profile`}
                              >
                                <i className="fa-brands fa-linkedin-in" />
                              </a>
                            )}
                          </div>
                        </div>

                        <div className="xb-bg digicomm-team-bg">
                          <img
                            src={bgSmall}
                            alt=""
                            aria-hidden="true"
                          />
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          {selectedMember && (
            <div
              className="leadership-modal-overlay"
              onClick={closeProfile}
            >
              <div
                className="leadership-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  className="leadership-modal-close"
                  onClick={closeProfile}
                  aria-label="Close profile"
                >
                  <i className="fa-solid fa-xmark" />
                </button>

                <div className="leadership-modal-grid">
                  <div className="leadership-modal-image">
                    <img
                      src={selectedMember.img}
                      alt={selectedMember.name}
                    />
                  </div>

                  <div className="leadership-modal-content">
                    <span className="leadership-modal-label">
                      Leadership Profile
                    </span>

                    <h2>{selectedMember.name}</h2>

                    <h4>{selectedMember.role}</h4>

                    <p className="leadership-modal-summary">
                      {selectedMember.summary}
                    </p>

                    <div className="leadership-modal-divider" />

                    <h5>About</h5>

                    <p className="leadership-modal-description">
                      {selectedMember.details}
                    </p>

                    <div className="leadership-modal-expertise">
                      {selectedMember.expertise.map((skill) => (
                        <span key={skill}>
                          {skill}
                        </span>
                      ))}
                    </div>

                    {selectedMember.linkedin && (
                      <a
                        href={selectedMember.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="leadership-modal-linkedin"
                      >
                        <i className="fa-brands fa-linkedin-in" />

                        <span>
                          View LinkedIn Profile
                        </span>

                        <i className="fa-solid fa-arrow-up-right-from-square" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

  </Fragment>);
};
export default TeamLeadership;

